import React, { useEffect } from "react";
import "../styles/Business.css";
import AOS from "aos";
import "aos/dist/aos.css";


import img1 from '../assets/power.png';
import img2 from '../assets/oil&gas.jpg';
import img3 from '../assets/infrastructure.png';
import img4 from '../assets/greenenergy.png';

import img5 from '../assets/electric6A.jpg';
import img6 from '../assets/oil&gas2A.avif';
import img7 from '../assets/electric5A.jpg';
import img8 from '../assets/solar3A.jpg';


const services = [
  { title: "Power", desc: "Electric power is the backbone of modern industry and daily life, enabling the efficient transmission and distribution of energy to homes, businesses, and infrastructure. By harnessing advanced technologies and sustainable practices, electric power systems ensure reliable, clean, and cost-effective energy solutions that drive economic growth and support environmental stewardship.", img: img1 },
  { title: "Oil & Gas", desc: "Oil and gas remain critical energy resources powering global industries and transportation. Through innovative exploration, extraction, and refining technologies, the sector continuously advances efficiency and safety while striving to reduce environmental impact. This dynamic industry plays a vital role in meeting the world’s growing energy demands and supporting economic development.", img: img2 },
  { title: "Infrastructure", desc: "Building and maintaining robust electric infrastructure is essential for powering communities and industries reliably and efficiently. Our services encompass design, installation, and upgrade of electrical grids, substations, and smart technologies to ensure seamless energy distribution. We prioritize safety, innovation, and sustainability to support the growing demands of modern urban and industrial environments.", img: img3 },
  { title: "Green Energy", desc: "Empowering a sustainable future through cutting-edge green energy solutions, we specialize in the development and integration of renewable electric systems such as solar, wind, and energy storage. Our services focus on reducing carbon footprints while enhancing energy efficiency and reliability. By leveraging innovative technologies and strategic planning, we help businesses and communities transition smoothly to clean, renewable power sources that drive environmental stewardship and economic growth.", img: img4 },
];

const Business = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });

    const radios = document.querySelectorAll("input[name='slider']");
    let index = 0;

    const interval = setInterval(() => {
      radios[index].checked = false;  // uncheck current
      index = (index + 1) % radios.length;
      radios[index].checked = true;   // check next
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <h2 className="biz-heading" data-aos="fade-down">Our Business</h2>
    <div className="biz-grid-container">
      <div className="biz-box top-left" data-aos="fade-right">
        <img src={services[0].img} alt={services[0].title} className="biz-icon" />
        <h3>{services[0].title}</h3>
        <p>{services[0].desc}</p>
      </div>

      <div className="biz-box top-right" data-aos="fade-left">
        <img src={services[1].img} alt={services[1].title} className="biz-icon" />
        <h3>{services[1].title}</h3>
        <p>{services[1].desc}</p>
      </div>

      {/* Center Carousel */}
     <div className="slider-container" data-aos="fade-up">
  <section id="slider">
    <input type="radio" name="slider" id="s1" defaultChecked />
    <input type="radio" name="slider" id="s2" />
    <input type="radio" name="slider" id="s3" />
    <input type="radio" name="slider" id="s4" />

    <div className="slide" id="slide1">
      <img src={img5} alt="Slide 1" />
    </div>
    <div className="slide" id="slide2">
      <img src={img6} alt="Slide 2" />
    </div>
    <div className="slide" id="slide3">
      <img src={img7} alt="Slide 3" />
    </div>
    <div className="slide" id="slide4">
      <img src={img8} alt="Slide 4" />
    </div>
  </section>
</div>


      <div className="biz-box bottom-left" data-aos="fade-right">
        <img src={services[2].img} alt={services[2].title} className="biz-icon" />
        <h3>{services[2].title}</h3>
        <p>{services[2].desc}</p>
      </div>

      <div className="biz-box bottom-right" data-aos="fade-left">
        <img src={services[3].img} alt={services[3].title} className="biz-icon" />
        <h3>{services[3].title}</h3>
        <p>{services[3].desc}</p>
      </div>
    </div>
    </>
    
  );
};

export default Business;
